import React from 'react';
import {
  Grid,
  Card,
  Box,
  Skeleton,
  Stack,
  Button,
  List,
  ListItem,
  useMediaQuery,
} from '@mui/material';
import { Circle, ReportProblemOutlined } from '@mui/icons-material';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import styles from './styles';
import EirLoader from '../eir-loader/EirLoader';

const EirAddonsCard = ({
  card,
  loading = true,
  addAddon,
  removeAddOn,
  showLoader,
  isHandset,
  openInsuranceModal,
  openDialog,
  //  setInsuranceAdded,
  mbbDescription,
  mbbDevices,
}) => {
  const theme = useTheme();
  const renderContent = content => ({ __html: content });
  const lg = useMediaQuery(theme.breakpoints.up('md'));

  const getInsuranceModal = () => {
    openInsuranceModal.enable();
  };
  return (
    <Grid
      item
      xs={12}
      md={mbbDevices || isHandset ? 6 : 4}
      lg={mbbDevices || isHandset ? 6 : 3}
      sx={{
        ...styles(theme).cardBox,
        padding: isHandset && lg ? '1rem 0.75rem 0 0.75rem' : '1rem 0.75rem 0.5rem 0.75rem',
      }}
    >
      <Card
        sx={{
          ...styles(theme).addon_cards,
          ...(card.AddonsSelected ? styles(theme).addon_cards_selected : {}),
          ...{ height: '100%' },
        }}
      >
        <Stack sx={{ textAlign: 'left' }}>
          {loading ? (
            <>
              <Skeleton
                variant='rectangular'
                sx={{ m: '0 auto', height: { xs: 90 }, width: { xs: 47 } }}
              />
              <Skeleton height={24} width='50%' sx={{ m: '1rem auto 0' }} />
              <Skeleton height={16} width='60%' sx={{ m: 'auto' }} />
              <Skeleton height={24} width='20%' sx={{ m: '1rem auto 0' }} />
            </>
          ) : (
            <Grid container xs={12}>
              <Grid
                xs={12}
                md={(mbbDevices || isHandset) && 'auto'}
                sx={{
                  ...styles(theme).addonCard_content_img,
                  background: `radial-gradient(130.50% 102.78% at 50.00% -15.20%, ${theme.palette.secondary.backgroundGrey} 0%, ${theme.palette.primary.header} 100%)`,
                }}
              >
                <Box
                  display={{ xs: 'block', md: 'none' }}
                  component='img'
                  alt={card.altText}
                  src={card.mobileImage}
                  sx={{ width: '100%', height: '95%' }}
                />
                <Box
                  display={{ xs: 'none', md: 'block' }}
                  component='img'
                  alt={card.altText}
                  src={mbbDevices || isHandset ? card.image : card.mobileImage}
                  sx={{ width: mbbDevices || isHandset ? '185px' : '100%', height: '100%' }}
                />
              </Grid>
              <Grid
                xs={12}
                md={(mbbDevices || isHandset) && 'auto'}
                sx={[
                  {
                    flex: { md: 1 },
                    backgroundColor: theme.palette.primary.backgroundColor4,
                  },
                  styles(theme).addonCard_content,
                ]}
              >
                <Grid sx={styles(theme).mbbMainTitleDiv}>
                  <Grid sx={styles(theme).mbbTitleDiv}>
                    <Typography
                      variant='subtitle1'
                      sx={{ paddingRight: 0.5, color: theme.palette.primary.textColor3 }}
                    >
                      {card.title}
                    </Typography>
                  </Grid>
                  {card?.orderIndex === 0 && (
                    <Grid sx={styles(theme).mbbOutOfStockTextMainDiv}>
                      <Grid sx={styles(theme).mbbOutOfStockTextDiv}>
                        <Typography variant='tooltip' sx={styles(theme).mbbOutOfStockText}>
                          Out of stock
                        </Typography>
                      </Grid>
                    </Grid>
                  )}
                </Grid>

                {mbbDescription ? (
                  <List dense>
                    {card?.description?.map((list, i) => (
                      <ListItem key={i}>
                        <Stack
                          direction='row'
                          alignItems={list.icon ? 'flex-start' : ''}
                          sx={{ width: '100%' }}
                        >
                          <Circle
                            sx={{
                              height: 5,
                              width: 5,
                              mt: '9.5px',
                            }}
                          />
                          <Typography
                            variant='body2'
                            color={theme.palette.primary.textColor3}
                            sx={{ pl: 1 }}
                          >
                            {list}
                          </Typography>
                        </Stack>
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  <Grid sx={isHandset || mbbDevices ? {} : styles(theme).addon_cards_description}>
                    {card?.description?.includes('tvChannelPopup') ? (
                      <Typography
                        variant='body1'
                        color={theme.palette.secondary.mobileActiveToggleBackground}
                        sx={{ paddingTop: 1 }}
                        dangerouslySetInnerHTML={renderContent(card?.description)}
                        onClick={() => {
                          openDialog();
                        }}
                      />
                    ) : (
                      <Typography
                        color={theme.palette.primary.textColor3}
                        variant='body1'
                        sx={{ paddingTop: 1 }}
                        dangerouslySetInnerHTML={renderContent(card?.description)}
                      />
                    )}
                  </Grid>
                )}
                {isHandset && (
                  <Typography
                    variant='inputLabel'
                    component='a'
                    sx={{
                      color: theme.palette.secondary.errorCTA,
                      textDecorationLine: 'underline',
                      paddingTop: 1,
                      paddingBottom: 1,
                    }}
                    target='_blank'
                    onClick={getInsuranceModal}
                  >
                    More Info
                  </Typography>
                )}
                {card?.orderIndex === 0 ? (
                  <Grid sx={styles(theme).selectNextOfferMainContainer}>
                    <Grid sx={styles(theme).reportProblemLogoDiv}>
                      <ReportProblemOutlined sx={{ color: theme.palette.primary.orange }} />
                    </Grid>
                    <Grid sx={styles(theme).selectNextOfferTextDiv}>
                      <Typography
                        variant='body2'
                        color={theme.palette.secondary.mobileActiveToggleBackground}
                        sx={styles(theme).selectNextOfferText}
                      >
                        Select another offer
                      </Typography>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid container xs={12} sx={styles(theme).addon_priceCtaContainer}>
                    {card.price !== 'Free' ? (
                      <Grid item xs={7.5} sx={{ display: 'inline-flex' }}>
                        {mbbDevices ? (
                          <>
                            <Typography variant='body1' sx={styles(theme).mbbDeviceCost}>
                              Device cost:
                            </Typography>
                            <Typography variant='subtitle1' sx={styles(theme).mbbPrice}>
                              {' '}
                              {card?.price}
                            </Typography>
                          </>
                        ) : (
                          <>
                            <Typography variant='h4' sx={styles(theme).price}>
                              + {card?.price}
                            </Typography>
                            <Typography variant='helperText' sx={styles(theme).a_month}>
                              a month
                            </Typography>
                          </>
                        )}
                      </Grid>
                    ) : (
                      <Grid Grid item xs={7.5} sx={{ display: 'inline-flex' }}>
                        {mbbDevices ? (
                          <>
                            <Typography variant='body1' sx={styles(theme).mbbDeviceCost}>
                              Device cost:
                            </Typography>
                            <Typography variant='subtitle1' sx={styles(theme).mbbPrice}>
                              {card?.price}
                            </Typography>
                          </>
                        ) : (
                          <Typography variant='h4' sx={styles(theme).price}>
                            {card?.price}
                          </Typography>
                        )}
                      </Grid>
                    )}
                    <Grid
                      item
                      xs={4.5}
                      sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
                    >
                      {!(showLoader.code === card.code) && (
                        <Button
                          sx={{
                            ...styles(theme)?.cta,
                            ...(card.AddonsSelected ? styles(theme).addonCtaSelected : {}),
                          }}
                          variant='buttonSmall'
                          onClick={() =>
                            card.AddonsSelected
                              ? removeAddOn(card.serviceGroup, card.code)
                              : addAddon(card.serviceGroup, card.code)
                          }
                          aria-label='Add Addon'
                        >
                          {!card.AddonsSelected ? <span>+&nbsp;</span> : ''}
                          {card.AddonsSelected ? 'Added' : 'Add'}
                          {card.AddonsSelected ? (
                            <CheckCircleOutlineOutlinedIcon
                              fontSize='small'
                              sx={styles(theme).addonCtaCheck}
                            />
                          ) : (
                            ''
                          )}
                        </Button>
                      )}
                      {showLoader?.code === card?.code && (
                        <EirLoader
                          loaderTitle={!card.AddonsSelected ? 'Adding' : 'Removing'}
                          buttonSize={{ width: '6.8rem', height: '1.875rem' }}
                          buttonTextSize={{ fontSize: theme.typography.body2.fontSize }}
                          loaderSpinnerSize={18}
                        />
                      )}
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Grid>
          )}
        </Stack>
      </Card>
      {/* </Paper> */}
    </Grid>
  );
};

export default EirAddonsCard;
